export default __webpack_public_path__ + "static/media/facebook.2cd26182.svg";